import * as types from './types'
import { createAction } from 'Utils/redux'

export const add = createAction(types.WORK_ORDER_ADD, 'payload')
